import axios from "axios";

const apiCall = ({ method, url, data, config }) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(
          axios({
            method,
            url,
            data,
            config
          }).then(resp => {
            if (resp) {
              if (resp.data.state_id == 0) return resp.data;
            }
          })
        );
      } catch (err) {
        reject(new Error(err));
      }
    }, 1000);
  });

export default apiCall;
